var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-h-100",staticStyle:{"background":"#fff"}},[_c('div',{staticStyle:{"padding":"20px","height":"90%"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }